import { policyDisplayName, type Policy } from "../../../state/policies";

/** A name-only reference must never guess between two documents with the same title. */
export function matchingPolicyId(
  policies: readonly Pick<Policy, "id" | "filename" | "title">[],
  name: string,
): string | undefined {
  const normalized = name.trim().toLocaleLowerCase();
  if (!normalized) return undefined;
  const matches = policies.filter(
    (policy) => policyDisplayName(policy).toLocaleLowerCase() === normalized,
  );
  return matches.length === 1 ? matches[0]?.id : undefined;
}

export function policyLibrarySearch(search: Record<string, unknown>): { q?: string } {
  return typeof search.q === "string" && search.q.trim()
    ? { q: search.q.trim().slice(0, 300) }
    : {};
}
